import { Action } from '@ngrx/store';

export class StocksExchangeWalletAction implements Action {

    public static getOrders = '[Stocks Exchange Wallet] get_orders';
    public static getOrdersError = '[Stocks Exchange Wallet] get_orders_error';
    public static getOrdersSuccess = '[Stocks Exchange Wallet] get_orders_success';

    public static getOrdersPristine = '[Stocks Exchange Wallet] get_orders_pristine';
    public static getOrdersPristineError = '[Stocks Exchange Wallet] get_orders_pristine_error';
    public static getOrdersPristineSuccess = '[Stocks Exchange Wallet] get_orders_pristine_success';

    public static getValidOrders = '[Stocks Exchange Wallet] get_valid_orders';
    public static getValidOrdersError = '[Stocks Exchange Wallet] get_valid_orders_error';
    public static getValidOrdersSuccess = '[Stocks Exchange Wallet] get_valid_orders_success';

    public static getOrder = '[Stocks Exchange Wallet] get_order';
    public static getOrderError = '[Stocks Exchange Wallet] get_order_error';
    public static getOrderSuccess = '[Stocks Exchange Wallet] get_order_success';

    public static closeOrder = '[Stocks Exchange Wallet] close_order';
    public static closeOrderError = '[Stocks Exchange Wallet] close_order_error';
    public static closeOrderSuccess = '[Stocks Exchange Wallet] close_order_success';

    public static resetOrder = '[Stocks Exchange Wallet] reset_order';

    public static getStrategies = '[Stocks Exchange Wallet] get_strategies';
    public static getStrategiesError = '[Stocks Exchange Wallet] get_strategies_error';
    public static getStrategiesSuccess = '[Stocks Exchange Wallet] get_strategies_success';

    public static getValidStrategies = '[Stocks Exchange Wallet] get_valid_strategies';
    public static getValidStrategiesError = '[Stocks Exchange Wallet] get_valid_strategies_error';
    public static getValidStrategiesSuccess = '[Stocks Exchange Wallet] get_valid_strategies_success';

    public static getStrategy = '[Stocks Exchange Wallet] get_strategy';
    public static getStrategyError = '[Stocks Exchange Wallet] get_strategy_error';
    public static getStrategySuccess = '[Stocks Exchange Wallet] get_strategy_success';

    public static closeStrategy = '[Stocks Exchange Wallet] close_strategy';
    public static closeStrategyError = '[Stocks Exchange Wallet] close_strategy_error';
    public static closeStrategySuccess = '[Stocks Exchange Wallet] close_strategy_success';

    public static resetStrategy = '[Stocks Exchange Wallet] reset_strategy';
    public static strategyNotFound = '[Stocks Exchange Wallet] strategy_not_found';

    public static orderUpdated = '[Stocks Exchange Wallet] order_updated';
    public static custodyUpdated = '[Stocks Exchange Wallet] custody_updated';
    public static strategyUpdated = '[Stocks Exchange Wallet] strategy_updated';
    public static getCustodyUpdates = '[Stocks Exchange Wallet] get_custody_updated';
    public static getExchangeUpdates = '[Stocks Exchange Wallet] get_exchange_updated';

    public static sendStrategy = '[Stocks Exchange Wallet] send_strategy';
    public static sendStrategyError = '[Stocks Exchange Wallet] send_strategy_error';
    public static sendStrategySuccess = '[Stocks Exchange Wallet] send_strategy_success';

    public static getTradingDates = '[Stocks Exchange Wallet] getTradingDates';
    public static getTradingDatesError = '[Stocks Exchange Wallet] getTradingDates_error';
    public static getTradingDatesSuccess = '[Stocks Exchange Wallet] getTradingDates_success';

    public static getOrderExecutionDate = '[Stocks Exchange Wallet] getOrderExecutionDate';
    public static getOrderExecutionDateError = '[Stocks Exchange Wallet] getOrderExecutionDateError';
    public static getOrderExecutionDateSuccess = '[Stocks Exchange Wallet] getOrderExecutionDateSuccess';

    public static getMyHistoricStrategies = '[Stocks Exchange Wallet] getMyHistoricStrategies';
    public static getMyHistoricStrategiesError = '[Stocks Exchange Wallet] getMyHistoricStrategiesError';
    public static getMyHistoricStrategiesSuccess = '[Stocks Exchange Wallet] getMyHistoricStrategiesSuccess';

    public static getOrdersSearch = '[Stocks Exchange Wallet] getOrdersSearch';
    public static getOrdersSearchError = '[Stocks Exchange Wallet] getOrdersSearch_error';
    public static getOrdersSearchSuccess = '[Stocks Exchange Wallet] getOrdersSearch_success';

    public static getStretegiesSearch = '[Stocks Exchange Wallet] getStretegiesSearch';
    public static getStretegiesSearchError = '[Stocks Exchange Wallet] getStretegiesSearch_error';
    public static getStretegiesSearchSuccess = '[Stocks Exchange Wallet] getStretegiesSearch_success';

    public static getInvestments = '[Stocks Exchange Wallet] get_investments';
    public static getInvestmentsError = '[Stocks Exchange Wallet] get_investments_error';
    public static getInvestmentsSuccess = '[Stocks Exchange Wallet] get_investments_success';

    public static getExchangeUpdatesErrors = '[Stocks Exchange Wallet] get_exchange_updated_error';

    constructor(
        public type: string,
        public payload?: any,
    ) { }

}
